package team.platforma.materialextension.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import materialextension.composeapp.generated.resources.Res
import materialextension.composeapp.generated.resources.right_arrow
import materialextension.composeapp.generated.resources.settings
import team.platforma.multiplatform_material_extension.ui.drop_down.DropDownFieldStyle
import team.platforma.multiplatform_material_extension.ui.drop_down.DropDownItemStyle
import team.platforma.multiplatform_material_extension.ui.drop_down.DropDownListStyle
import team.platforma.multiplatform_material_extension.ui.drop_down.DropDownTextFieldStyle

class DropDownFieldTheme {
    @Composable
    fun light() {
        println("Define style")
        DropDownFieldStyle.define(
            style = DropDownListStyle(
                dropDownItemStyle = DropDownItemStyle(
                    itemBackgroundColor = Color.Blue,
                    selectedItemBackgroundColor = Color.Red,
                    itemTextColor = Color.Yellow,
                    selectedItemTextColor = Color.White,
                    selectedItemEndIcon = Res.drawable.settings,
                    selectedItemEndIconTint = Color.Magenta,
                    textItemStyle = TextStyle(),
                    selectedTextStyle = TextStyle()
                ),
                dropDownListStyle = DropDownTextFieldStyle(
                    endIcon = null,
                    iconTint = Color.Cyan,
                    textFieldColors = null,
                    dropDownListBackgroundColor = Color.White
                )
            ), outlinedStyle = DropDownListStyle(
                dropDownItemStyle = DropDownItemStyle(
                    itemBackgroundColor = Color.Blue,
                    selectedItemBackgroundColor = Color.Red,
                    itemTextColor = Color.Yellow,
                    selectedItemTextColor = Color.White,
                    selectedItemEndIcon = Res.drawable.settings,
                    selectedItemEndIconTint = Color.Magenta,
                    textItemStyle = TextStyle(),
                    selectedTextStyle = TextStyle()
                ),
                dropDownListStyle = DropDownTextFieldStyle(
                    endIcon = null,
                    iconTint = Color.Cyan,
                    textFieldColors = null,
                    dropDownListBackgroundColor = Color.White
                )
            )
        )
    }

//    @Composable
//    fun dark() {
//        DropDownFieldStyle.define(
//            DropDownListStyle()
//        )
//    }
}